import * as normalize from 'utils/normalize';
import getSignature from 'utils/print/getSignature';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getOrderLineDriverFullName from 'utils/print/getOrderLineDriverFullName';
import getSignatureDate from 'utils/print/getSignatureDate';

const DeliveryTicketPatientRightsAndResponsibilities = {
  ID: 20,
  Name: 'Patient Rights And Responsibilities',
  Type: 'Delivery Ticket',
  Format: 'letter',
  Orientation: 'p',
  OrderLineMax: 7,
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-Patient-Rights-And-Responsibilities/1.js',
      texts: [
        {
          name: 'Business Name 1',
          getText: props => getFacilityName(props) || getBusinessName(props),
          x: 108,
          y: 5,
          align: 'center',
          fontStyle: 'italic',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Name 2',
          getText: props => getFacilityName(props) || getBusinessName(props),
          x: 88,
          y: 90,
          align: 'center',
          fontStyle: 'italic',
          fontWeight: 'bold',
          fontSize: 9,
          lineHeight: 1.2,
        },
        {
          name: 'Copy 1',
          getText: props => `You have been provided with a copy of ${getFacilityName(props) || getBusinessName(props)} "Notice of Privacy Practices" that describes how we will use health information concerning our services to you. The notice details how we will use this information to provide treatment care for you, to gain reimbursement for our services and to improve our operations to better serve you and other patients.`,
          x: 12,
          y: 94,
          fontSize: 6,
          width: 188,
          lineHeight: 1.2,
        },
        {
          name: 'Copy 2',
          getText: props => `${getFacilityName(props) || getBusinessName(props)} will notify you of changes in our Notice of Privacy Practices prior to
implementing those changes.`,
          x: 29.5,
          y: 107,
          fontSize: 6,
          width: 170,
          lineHeight: 1.5,
        },
        {
          name: 'Copy 3',
          getText: props => `You may request restrictions as to how your health information may be used although ${getFacilityName(props) || getBusinessName(props)}
is not required to agree to those restrictions.`,
          x: 29.5,
          y: 113.5,
          fontSize: 6,
          width: 170,
          lineHeight: 1.5,
        },
        {
          name: 'Copy 4',
          getText: props => `Any restrictions to which ${getFacilityName(props) || getBusinessName(props)} agrees to, will be respected.`,
          x: 29.5,
          y: 120,
          fontSize: 6,
          width: 170,
          lineHeight: 1.5,
        },
        {
          name: 'Copy 5',
          getText: props => `You may revoke this consent in writing at any time, although ${getFacilityName(props) || getBusinessName(props)} can proceed
with uses and disclosers that pertain to treatment, payment, or healthcare issues that take place before
the consent was revoked.`,
          x: 29.5,
          y: 123,
          fontSize: 6,
          width: 170,
          lineHeight: 1.5,
        },
        {
          name: 'Copy 6',
          getText: props => `I have been provided with a Notice of Information Practices that provides specific examples and
descriptions of how my personal health information is used and discloses by ${getFacilityName(props) || getBusinessName(props)}.`,
          x: 29.5,
          y: 181.5,
          fontSize: 6,
          width: 170,
          lineHeight: 1.5,
        },
        {
          name: 'Copy 7',
          getText: props => `${getFacilityName(props) || getBusinessName(props)} can change its Notice of Information Practices but notify me of those
changes before they are put into practice and will mail me a copy of the New Notice to the address
that I have provided.`,
          x: 29.5,
          y: 191,
          fontSize: 6,
          width: 170,
          lineHeight: 1.5,
        },
        {
          name: 'Copy 8',
          getText: props => `I have the right to request restrictions as to how my health information may be used or disclosed
to carry out treatment, payment or health care operations and that ${getFacilityName(props) || getBusinessName(props)} is not
required to agree to those restrictions.`,
          x: 29.5,
          y: 200.5,
          fontSize: 6,
          width: 170,
          lineHeight: 1.5,
        },
        {
          name: 'Copy 9',
          getText: props => `Any restrictions to which ${getFacilityName(props) || getBusinessName(props)} agrees to will be respected`,
          x: 29.5,
          y: 210,
          fontSize: 6,
          width: 170,
          lineHeight: 1.5,
        },
        {
          name: 'Copy 10',
          getText: props => `I may revoke this consent in writing at any time. Further, I am aware that ${getFacilityName(props) || getBusinessName(props)}
can proceed with uses and disclosures that pertain to treatment, payment, or healthcare issues that
took place before the consent was revoked.`,
          x: 29.5,
          y: 213.5,
          fontSize: 6,
          width: 170,
          lineHeight: 1.5,
        },
      ],
      fields: [
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 20,
          y: 232,
          width: 90,
          height: 18,
        },
        {
          name: 'Driver Name',
          type: 'text',
          getValue: props => getOrderLineDriverFullName({ ...props, index: 0 }),
          x: 114,
          y: 244,
          width: 62,
        },
        {
          name: 'Date of Delivery',
          type: 'text',
          getValue: getSignatureDate,
          x: 178,
          y: 244,
          width: 27,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default DeliveryTicketPatientRightsAndResponsibilities;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-Patient-Rights-And-Responsibilities.js